import React from 'react'
import { Video } from '../../../atoms'

interface YoutubeLiteProps {
  name: string
  jsonBody: any
  variant: string
  rawName: string
  sys?: {
    id: string
  }
  showHeader: boolean
}

const YoutubeLite: React.FC<YoutubeLiteProps> = ({
  jsonBody,
  name,
  sys,
  rawName,
  variant,
  showHeader,
}) => {
  const { videoId, title } = jsonBody

  try {
    return (
      <div className='YoutubeLite' id={name}>
        {showHeader && title && <h2 className='YoutubeLite__header'>{title}</h2>}
        {/* @ts-ignore */}
        <Video videoId={videoId} rawName={rawName} variant={variant} title={title} id={sys?.id} />
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default YoutubeLite
